
import { format } from "date-fns"
import { SleepFormData } from "../SleepFormContext"

export const getDefaultTimes = () => {
  // Create dates in local timezone and ensure timezone is preserved
  const defaultStartTime = new Date()
  const defaultEndTime = new Date(defaultStartTime)
  defaultEndTime.setMinutes(defaultEndTime.getMinutes() + 30)
  
  return {
    defaultStartTime,
    defaultEndTime,
    defaultStartTimeInput: format(defaultStartTime, 'HH:mm'),
    defaultEndTimeInput: format(defaultEndTime, 'HH:mm')
  }
}

export const isCurrentStepValid = (currentStep: string, values: Partial<SleepFormData>) => {
  switch (currentStep) {
    case 'start':
      return !!values.start_time && !!values.start_time_input
    case 'wake_status':
      return !!values.has_woken_up
    case 'end':
      // End time is optional - always valid
      return true
    case 'restfulness':
      // Restfulness is optional when woken up, so always valid
      return true
    case 'location':
      return !!values.location_id
    case 'environment':
      return !!values.environment_id
    case 'onset':
      return !!values.onset_method_id
    case 'sound':
      return !!values.sound_id
    case 'sound_level':
      return !!values.sound_level_id
    case 'sleep_debt':
      return true
    case 'notes':
      return true
    default:
      return false
  }
}

export const getValidationMessage = (currentStep: string) => {
  switch (currentStep) {
    case 'restfulness':
      return 'Please select a restfulness rating'
    case 'location':
      return 'Please select a location'
    case 'environment':
      return 'Please select an environment'
    case 'onset':
      return 'Please select an onset method'
    case 'sound':
      return 'Please select a sound'
    case 'sound_level':
      return 'Please select a sound level'
    default:
      return ''
  }
}
